module.exports = __webpack_public_path__ + "img/logo-flood4cast.3b852594.png";